import { render, staticRenderFns } from "./SSResult.vue?vue&type=template&id=520f45ff&scoped=true&"
import script from "./SSResult.vue?vue&type=script&lang=js&"
export * from "./SSResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520f45ff",
  null
  
)

export default component.exports